export default {
  namespaced: true,
  state: {
    loading: false,
    showClientPanel: false,
    showTaskPanel: false,
    showOpportunityPanel: false,
    showOpportunityDetailPanel: false,
    showTractorPanel: false,
    showNotesPanel: false,
    showPrevTaskPanel: false,
    showPrevNotePanel: false,
    showTrackingPanel: false,
    showCampaignPanel: false,
    showCampaignAssignPanel: false,
    showCampaignSubjectPanel: false,
    showCampaignMailPanel: false,
    showCampaignCreatePanel: false,
    showCampaignEditPanel: false,
    showCampaignListPanel: false,
    showPreviewMail: false,
    showGoalsPanel: false,
    showApprovePanel: false,
    activeTab: 'customers-info'
  },
  getters: {
    loading: state => {
      return state.loading
    },
    showClientPanel (state) {
      return state.showClientPanel
    },
    showTractorPanel (state) {
      return state.showTractorPanel
    },
    showTaskPanel (state) {
      return state.showTaskPanel
    },
    showOpportunityPanel (state) {
      return state.showOpportunityPanel
    },
    showOpportunityDetailPanel (state) {
      return state.showOpportunityDetailPanel
    },
    showNotesPanel (state) {
      return state.showNotesPanel
    },
    showPrevTaskPanel (state) {
      return state.showPrevTaskPanel
    },
    showPrevNotePanel (state) {
      return state.showPrevNotePanel
    },
    showTrackingPanel (state) {
      return state.showTrackingPanel
    },
    showCampaignPanel (state) {
      return state.showCampaignPanel
    },
    showCampaignAssignPanel (state) {
      return state.showCampaignAssignPanel
    },
    showCampaignSubjectPanel (state) {
      return state.showCampaignSubjectPanel
    },
    showCampaignMailPanel (state) {
      return state.showCampaignMailPanel
    },
    showCampaignCreatePanel (state) {
      return state.showCampaignCreatePanel
    },
    showCampaignEditPanel (state) {
      return state.showCampaignEditPanel
    },
    showCampaignListPanel (state) {
      return state.showCampaignListPanel
    },
    showPreviewMail (state) {
      return state.showPreviewMail
    },
    showGoalsPanel (state) {
      return state.showGoalsPanel
    },
    showApprovePanel (state) {
      return state.showApprovePanel
    },
    activeTab (state) {
      return state.activeTab
    }
  },
  mutations: {
    loading (state, payload) {
      state.loading = payload
    },
    changeActiveTab (state, payload) {
      state.activeTab = payload
    },
    toggleClientPanel (state) {
      state.showClientPanel = !state.showClientPanel
    },
    toggleOpportunityPanel (state) {
      state.showOpportunityPanel = !state.showOpportunityPanel
    },
    toggleOpportunityDetailPanel (state) {
      state.showOpportunityDetailPanel = !state.showOpportunityDetailPanel
    },
    toggleTractorPanel (state) {
      state.showTractorPanel = !state.showTractorPanel
    },
    toggleNotesPanel (state) {
      state.showNotesPanel = !state.showNotesPanel
    },
    toggleTasksPanel (state) {
      state.showTaskPanel = !state.showTaskPanel
    },
    togglePrevTaskPanel (state) {
      state.showPrevTaskPanel = !state.showPrevTaskPanel
    },
    togglePrevNotesPanel (state) {
      state.showPrevNotePanel = !state.showPrevNotePanel
    },
    toggleTrackingPanel (state) {
      state.showTrackingPanel = !state.showTrackingPanel
    },
    toggleCampaignPanel (state) {
      state.showCampaignPanel = !state.showCampaignPanel
    },
    toggleCampaignAssignPanel (state) {
      state.showCampaignAssignPanel = !state.showCampaignAssignPanel
    },
    toggleCampaignSubjectPanel (state) {
      state.showCampaignSubjectPanel = !state.showCampaignSubjectPanel
    },
    toggleCampaignMailPanel (state) {
      state.showCampaignMailPanel = !state.showCampaignMailPanel
    },
    toogleCampaignCreatePanel (state) {
      state.showCampaignCreatePanel = !state.showCampaignCreatePanel
    },
    toogleCampaignEditPanel (state) {
      state.showCampaignEditPanel = !state.showCampaignEditPanel
    },
    toggleCampaignListPanel (state) {
      state.showCampaignListPanel = !state.showCampaignListPanel
    },
    toogglePreviewMail (state) {
      state.showPreviewMail = !state.showPreviewMail
    },
    tooglesGoalsPanel (state) {
      state.showGoalsPanel = !state.showGoalsPanel
    },
    toggleApprovePanel (state) {
      state.showApprovePanel = !state.showApprovePanel
    }

  },
  actions: {
    loading ({commit}, payload) {
      commit('loading', payload)
    },
    changeActiveTab ({commit}, payload) {
      commit('changeActiveTab', payload)
    },
    toggleClientPanel ({commit}) {
      commit('toggleClientPanel')
    },
    toggleOpportunityPanel ({commit}) {
      commit('toggleOpportunityPanel')
    },
    toggleOpportunityDetailPanel ({commit}) {
      commit('toggleOpportunityDetailPanel')
    },
    toggleTractorPanel ({commit}) {
      commit('toggleTractorPanel')
    },
    toggleNotesPanel ({commit}) {
      commit('toggleNotesPanel')
    },
    toggleTasksPanel ({commit}) {
      commit('toggleTasksPanel')
    },
    togglePrevTaskPanel ({commit}) {
      commit('togglePrevTaskPanel')
    },
    togglePrevNotesPanel ({commit}) {
      commit('togglePrevNotesPanel')
    },
    toggleTrackingPanel ({commit}) {
      commit('toggleTrackingPanel')
    },
    toggleCampaignPanel ({commit}) {
      commit('toggleCampaignPanel')
    },
    toggleCampaignAssignPanel ({commit}) {
      commit('toggleCampaignAssignPanel')
    },
    toggleCampaignSubjectPanel ({commit}) {
      commit('toggleCampaignSubjectPanel')
    },
    toggleCampaignMailPanel ({commit}) {
      commit('toggleCampaignMailPanel')
    },
    toggleCampaignCreatePanel ({commit}) {
      commit('toogleCampaignCreatePanel')
    },
    toggleCampaignEditPanel ({commit}) {
      commit('toogleCampaignEditPanel')
    },
    toggleCampaignListPanel ({commit}) {
      commit('toggleCampaignListPanel')
    },
    toogglePreviewMail ({commit}) {
      commit('toogglePreviewMail')
    },
    tooglesGoalsPanel ({commit}) {
      commit('tooglesGoalsPanel')
    },
    toggleApprovePanel ({commit}) {
      commit('toggleApprovePanel')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/app.store.js